import { idb } from "../../root/idb.js";
import { incomingMessagesTypes } from "../../root/modules/incoming-messages/data/incoming-messages-types.js";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { useMainStore } from "../store/mainStore.js";

const silenceAlertLog = log(loggingContexts.silenceAlert);

export const silenceAlert = ({ message }) => {
  const {
    message: { alertID, caseID, group, productKey },
  } = message;

  const mainStore = useMainStore();

  const productKeyMatches = productKey === mainStore.productKey;
  const groupMatches = group === mainStore.group && !!mainStore.group;

  if (productKeyMatches || groupMatches) {
    silenceAlertLog.info(
      "silencing because product key",
      productKeyMatches,
      productKey,
      mainStore.productKey
    );

    silenceAlertLog.info(
      "silencing because group",
      groupMatches,
      group,
      mainStore.group
    );

    silenceAlertLog.info("alertID to silence", { alertID });
    silenceAlertLog.info("caseID to silence", { caseID });

    silenceAlertByAlertIDAndCaseID({ alertID, caseID });
  }
};

const silenceAlertByAlertIDAndCaseID = async ({ alertID, caseID }) => {
  const connection = await idb();

  let cursor = await connection
    .transaction("incomingMessages", "readwrite")
    .store.index("timestamp")
    .openCursor(undefined, "prev");

  let count = 0;
  let found = false;

  while (cursor) {
    count += 1;

    if (count > 2000) {
      await cursor.delete();
    } else {
      let { value: incomingMessage } = cursor;

      if (incomingMessage.id === alertID) {
        incomingMessage.silenced = true;

        silenceAlertLog.info(
          "alert to silence found",
          alertID,
          caseID,
          incomingMessage
        );

        await cursor.update(incomingMessage);

        found = true;
      }

      if (
        found === true &&
        incomingMessage.caseID === caseID &&
        incomingMessage.id !== alertID
      ) {
        if (incomingMessage.silenced === false) {
          incomingMessage.silenced = true;

          silenceAlertLog.info(
            "previously received unsilenced alert found",
            alertID,
            caseID,
            incomingMessage
          );

          await cursor.update(incomingMessage);
        }
      }

      if (
        incomingMessage.type === incomingMessagesTypes.CheckConnectivity ||
        //  needs the check above for retro-compatibility, at least until no Alerter has this message type stored
        incomingMessage.type ===
          incomingMessagesTypes.ConnectivityCheckToMessagingServers
      ) {
        await cursor.delete();
      }
    }

    cursor = await cursor.continue();
  }
};
